import templateUrl from "emun.invoice/credit-request/credit-request-summary-actions.htm";
export default () => ({ templateUrl });
